import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WFWorker } from 'src/app/store/events.era';
import { publicEditProfileStatusTypes, SocialLink } from '../../store/performers.era';
import { JoiEvent, Label, Ranking } from 'globals/store/events.data';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { ManageWrapperComponent, TabGroup } from '../manage/manage-wrapper.component';
import { manageSessionReadonlyReselector } from 'src/app/store/reselectors/sessions.reselector';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { Program } from 'globals/store/programs.data';
import { JoiComment } from 'globals/store/tasks.data';
import { BriefInfo, ItemStatus, PublicEditProfileInfo } from 'globals/store/share.data';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from 'src/app/components/wrapper.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { ClipLabel } from 'globals/store/entity.data';
import { AssetBriefAction, BriefActions } from '../../store/share.brief.functions';
import { UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { Attendee, attendeeTabs } from 'globals/store/attendees.data';
import { attendeeBriefActionsReselector, sessionAttendeeReselector } from '../../store/reselectors/attendees.reselector';
import { NestedProgramInfo, PerformerSessionInfo, SessionInfo } from '../../store/reselectors/performerSponsors.reselector';
import { SessionSelectorData, SessionSelectorDialogComponent } from '../../components/performers/session-selector.dialog.component';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { ManageSessionComponent, ManageSessionData } from '../manage/manage-session.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { BigAndGreyComponent } from 'src/app/components/cards/big-and-grey.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { CustomQuestionsAppComponent } from 'src/app/components/entities/custom-questions-app.component';
import { environment } from '../../../environments/environment';
import { EntityTypesComponent } from 'src/app/components/entities/entity-types.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { CommonModule } from '@angular/common';
import { ManageSocialLinksComponent } from '../manage/manage-social.component';
import { ManageContactDetailsComponent } from '../manage/manage-contact-details.component';
import { ManageContactComponent } from '../manage/manage-contact.component';
import { ChatBoxComponent } from '../manage/chat-box.component';
import { EntityTasksComponent } from '../manage/entity-tasks.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { InformableComponent } from 'src/app/components/informable/informable.component';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';
import { ManageTermsComponent } from '../manage/manage-terms.component';
import { AppBriefComponent } from '../entities/app-brief.component';

@Component({
    selector: 'manage-attendee',
    templateUrl: './manage-attendee.html',
    styleUrls: ['../manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, EntityTypesComponent, AddManageWrapperComponent, StatusWrapperComponent, CommonModule, BigAndGreyComponent, TipTextComponent, BinaryShareToggle, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, ManageContactDetailsComponent, CustomQuestionsAppComponent, ManageContactComponent, ChatBoxComponent, EntityTasksComponent, TitleIconComponent, InformableComponent, AddLinkToBriefComponent, ManageTermsComponent, AppBriefComponent],
})
export class ManageAttendeeDialogComponent extends Wrapper<ManageAttendeeDialogComponent> implements OnInit {
  attendee: Attendee
  
  labels: Label[] = []
  labelMap: { [id:string]: Label }
  contact: WFWorker
  imageUploaderDisplayTypes = imageUploaderDisplayTypes

  attendeeShareBaseUrl = environment.joi.shareBase + 'attendee/';
  attendeeShareable: PublicEditProfileInfo;
  attendeeBriefs: Dictionary<BriefInfo> = {}
  generatingEditCode = false;
  event: JoiEvent
  standTypes: { [id:string]: Ranking } = {}
  programs: { [pId:string]: Program } = {}
  tabs = attendeeTabs
  tabGroups: TabGroup[] = [{ tabs: [
    { id: attendeeTabs.info, name: 'Attendee profile' },
    { id: attendeeTabs.sessions, name: 'Sessions' },
    { id: attendeeTabs.schedule, name: 'Schedule' },
    { id: attendeeTabs.quickNotes, name: 'Quick Notes', icon: 'sticky18' },
    { id: attendeeTabs.contact, name: 'Workforce contact' },
    { id: attendeeTabs.tasks, name: 'Tasks' },
  ]},{
    groupName: 'ATTENDEE BRIEF',
    tabs: [
      
    { id: attendeeTabs.briefInfo, name: 'Information for attendee' },
      { id: attendeeTabs.configBrief, name: 'Manage actions' },
      { id: attendeeTabs.preview, name: 'Share brief' },
    ]
  }]
  selectedTab
  clipLabel: ClipLabel
  readOnly: boolean
  briefActions: BriefActions // for use in manage actions, apparently was not passed into brief view from here
  sessionProgramList: NestedProgramInfo[] = []
  sessionList: SessionInfo[] = []
  threeDotSessionOptions = [{ name: 'Untag attendee from session', id: 'delete' }]

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageAttendeeDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageAttendeeData) {
    super()
    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('programs', 'entities'), 'programs')
    this.subProp(this.store.select('shareables', 'attendee', data.attendeeId), 'attendeeShareable')
    this.take1(this.store.select('informables', 'attendee', this.data.attendeeId)).then((informable)=>{
      if (!informable) this.informablesService.checkIfEntityDefaultsAreNeeded('attendee',this.eventService.eventId, this.data.attendeeId)
    })
    this.subProp(this.store.select('shareables','attendeeBrief'), 'attendeeBriefs')
    this.selectCallback(sessionAttendeeReselector, this.data.attendeeId, ({ sessionList, sessionProgramList }) => {
      this.sessionList = sessionList
      this.sessionProgramList = sessionProgramList
    })
    
    this.selectProp(attendeeBriefActionsReselector, this.data.attendeeId, 'briefActions')
  }

  addToASession(event) {
    const data: SessionSelectorData = { nestedProgramList: this.sessionProgramList, ...getXYFromEventAndWidth(event, 300), attendeeId: this.data.attendeeId }
    this.dialog.open(SessionSelectorDialogComponent, { width: '300px', data, backdropClass: 'clear', disableClose: true })
  }
  
  async manageSession(session: SessionInfo) {
    const data: ManageSessionData = { sessionId: session.id }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
    console.log(session)
  }

  saveStars(stars: number) {
    this.attendee = { ...this.attendee, stars }
    this.saveAttendee()
  }

  sessionDotMenuSelection({ event, option }, session: SessionInfo) {
    console.log(session, event, option)
    switch (option) {
      case 'delete':
        this.deleteFromSession(session, event)        
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
}

  async deleteFromSession(sessionInfo: SessionInfo, event: Event) {
    // Confirmation is nested in the status-wrapper component
    const rect = (<HTMLElement>event.target).getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Untag ' + this.attendee.name + ' from this session',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    
    const session = sessionInfo.fullSession
    session.attendeeTags = session.attendeeTags.filter(t => t !== this.data.attendeeId)
    this.programService.updateSession(sessionInfo.programId, session)
  }



  ngOnInit() {
    this.subCallback(this.store.select('events', 'labelMaps', 'attendee_labels'), labels => {
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    this.subProp(this.store.select('attendees', 'entities', this.data.attendeeId), 'attendee')
    this.subProp(this.store.select(manageSessionReadonlyReselector), 'readOnly')
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      this.attendee.labels = labels
      this.attendeeService.updateAttendee(this.attendee)
    }
    if (labelsChanged ) {
      this.eventService.updateEvent(this.eventService.eventId, { attendee_labels: labelTemplate })
    }
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.attendeeService.templateAttendees([this.attendee])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }

  setAssetStatus(status: ItemStatus, pa: AssetBriefAction) {
    this.assetService.changeAssetStatus(pa.assetId, status)
  }

  shareUrl(shareOn: boolean) {
    const brief = this.attendeeBriefs[this.attendee.id]
    if (!brief) {
      this.shareBriefsService.addNewBrief('attendee', this.attendee.id)
      return
    }
    this.shareBriefsService.changeBriefShareStatus(brief, shareOn ? 'On' : 'Off')
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

  saveSocialLinks(links: SocialLink[]) {
    this.attendee.social = links
    this.saveAttendee()
  }

  changeImage(result) {
    this.attendee.photoUrl = result ? result.thumbUrl : null
    this.attendee.fullPhotoUrl = result ? result.photoUrl : null
    this.saveAttendee()
  }

  exit() {
    this.dialogRef.close()
  }

  toggleAttendeeConfirmed() {
    this.attendee.confirmed = !this.attendee.confirmed
    this.saveAttendee()
  }


  updateAttendeeName(name: string) {
    this.attendee.name = name
    this.saveAttendee()
  }

  toggleAttendeeProfile() {
    if (!this.attendeeShareable) {
      this.createAttendeeProfileShareable()
    } else if (this.attendeeShareable.status !== publicEditProfileStatusTypes.Off) {
      this.changeAttendeeProfileStatus(publicEditProfileStatusTypes.Off)
    } else {
      this.changeAttendeeProfileStatus(publicEditProfileStatusTypes.Active)
    }
  }

  async createAttendeeProfileShareable () {
    this.generatingEditCode = true;
    await this.shareService.createEditProfileCode(this.attendee.id, this.event.eventId, 'attendee')
    this.generatingEditCode = false
  }

  changeAttendeeProfileStatus(status){
    const profile: PublicEditProfileInfo = { code: this.attendeeShareable.code, status, attendeeId: this.attendee.id }
    // console.log({ profile })
    this.shareService.updateProfileInfo(profile)
  }

  updateShowEditProfileLinkInBrief(){
    this.attendee = { ...this.attendee, showEditProfileLinkInBrief: !this.attendee.showEditProfileLinkInBrief }
    this.saveAttendee()
    if (!this.attendeeShareable) this.createAttendeeProfileShareable()
    else if (this.attendee.showEditProfileLinkInBrief && this.attendeeShareable?.status !== 'Active') this.changeAttendeeProfileStatus('Active')
  }
  
  async changeWorkforceContact(personEmail: string) {
    const WFContact = personEmail === this.attendee.WFContact ? null : personEmail
    this.attendee = { ...this.attendee, WFContact }
    this.saveAttendee()
  }

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.attendee.customQuestions[id] = answer
    this.saveAttendee()
  }

  saveAttendee() {
    this.attendeeService.updateAttendee(this.attendee)
  }

  async deleteAttendee() {
    this.dialogRef.close()
    this.attendeeService.deleteAttendee(this.attendee)
  }

  async duplicateAttendee() {
    this.dialogRef.close()
    this.attendeeService.duplicateAttendee(this.attendee)
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    // console.log({ quickNotes })
    this.attendee.quickNotes = quickNotes
    this.saveAttendee()
  }

}

export interface ManageAttendeeData {
  attendeeId: string
  nested?: boolean
  readOnly?: boolean
}
